import React, { Component, createRef } from 'react';
import Loader from "../../utils/Loader";
import Footer from "../../common_components/Footer";
import Header from "../../common_components/Header";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import moment from "moment";
import { Modal } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
    getCmsContent_action, insertUpdateCmsContent_action,
    insertUpdateCmsFooter_action, publishCmsContent_action,
    publishCmsFooter_action, insertUpdateCmsContentSection_action,
    updateCmsContentStatus_action, insertUpdateCMSStaticUploads_action,
    deleteCmsStaticFiles_action, publishCmsBanner_action, insertUpdateCmsBanner_action
} from "../../actions/cms_action/cmsAction";
import { BASE_URL, toastError, toastSuccess } from '../../utils/constants';
import { ToastContainer } from 'react-toastify';
import Resizer from "react-image-file-resizer";
import { fullsize } from 'jodit/esm/plugins/fullsize/fullsize';

const joditConfig = {
    readonly: false,
    height: 500,
    disableBeautify: true,
    useAceEditor: false,
    uploader: { insertImageAsBase64URI: true },
    showAbout: false,
    showPoweredBy: false,

    // ✅ Default style for editor content
    defaultStyle: 'color: black; font-family: Arial, sans-serif; font-size: 14px;',

    // ✅ Toolbar buttons
    buttons: [
        'bold', 'strikethrough', 'underline', 'italic', '|',
        'ul', 'ol', '|',
        'outdent', 'indent', '|',
        'image', 'video', 'table', 'link', '|',
        'fontsize', 'font', 'brush', 'paragraph', '|', // ✅ added font selector here
        'align', "undo", "redo", "search", '|',
        'source',
        {
            name: "more",
            iconURL: "https://cdn-icons-png.flaticon.com/512/130/130884.png",
            tooltip: "More Options",
            list: ["superscript", "subscript", "copyformat", "print", "hr", 'copyformat'],
        },
    ],

    // ✅ Toolbar on small screens
    buttonsXS: [
        'bold', 'image', '|', 'font', 'brush', 'paragraph', '|',
        'align', '|', 'undo', 'redo', '|', 'eraser', 'dots', 'more', 'source'
    ],

    buttonsSM: [
        "bold", "italic", "underline", "link", "font", "more", "source"
    ],

    // ✅ Styling toolbar
    style: {
        toolbar: {
            display: "flex",
            justifyContent: "space-between"
        },
    },

    dropdown: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "10px",
        padding: "10px",
    },

    // ✅ Default fonts and color options
    controls: {
        font: {
            // Font family dropdown like MS Word
            list: {
                'Arial, sans-serif': 'Arial',
                'Calibri, sans-serif': 'Calibri',
                'Times New Roman, serif': 'Times New Roman',
                'Georgia, serif': 'Georgia',
                'Verdana, sans-serif': 'Verdana',
                'Courier New, monospace': 'Courier New'
            }
        },
        fontsize: {
            // Font size dropdown options
            list: {
                '10px': '10',
                '12px': '12',
                '14px': '14',
                '16px': '16',
                '18px': '18',
                '20px': '20',
                '24px': '24',
                '28px': '28',
                '32px': '32'
            }
        },
        brush: {
            color: '#000000' // Default text color in color picker
        }
    },

    toolbarAdaptive: false,
    toolbarSticky: false,
    toolbarButtonSize: "middle",

    // Optional: start full-size editor
    // fullsize:true
};


let sectionCounter = 1;
class cmsHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            currentIndex: 0,
            isStaticUploadOpen: false,
            isStaticUploadOpenBanner: false,
            //cms
            cmsSectionData: [],
            cmsMenuData: [],
            cmsFooterData: [], MenuUrl: '',
            MenuID: '', ContentID: '', SectionName: '',
            SeqNo: '', isFixed: '', isEdit: '', SectionContent: '',
            isactive: '', isPublish: '',
            cmsUploadData: [], downloadUrl: '',
            cmsSubheaderData: [], cmsBannerData: [], bannerFileErr: ''

        }
        this.sectionRefs = [];
        this.slider3Ref = React.createRef()
        this.clearFileInput = this.clearFileInput.bind(this)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        const sortUrl = BASE_URL.split("/api");
        this.setState({ downloadUrl: sortUrl[0] });

        if (this.props.location.pathname == '/cms/manage') {
            this.setState({ MenuUrl: 'home', MenuID: 1, cmsMenuData: [] }, () => {
                this.getCmsContent(1, 'home');
            }, () => {
                this.runDynamicScripts()
            });
            return
        } else {
            const path = this.props.location.pathname; // e.g., '/cms/manage/current-awards&4'
            const cmsPrefix = '/cms/manage/';

            if (path.startsWith(cmsPrefix)) {
                const subPath = path.slice(cmsPrefix.length); // gets 'current-awards&4'
                console.log(path, subPath, 'cmspath')

                const parts = subPath.split('&');

                if (parts.length === 2) {
                    const MenuUrlProps = parts[0]; // 'current-awards'
                    const MenuIDProps = parts[1];
                    this.setState({ MenuUrl: MenuUrlProps, MenuID: MenuIDProps, cmsMenuData: [] }, () => {
                        this.getCmsContent(MenuIDProps ? MenuIDProps : 1, MenuUrlProps ? MenuUrlProps : 'home');
                    }, () => {
                        this.runDynamicScripts()
                    });
                    // }
                }
            }
        }
    }
    componentDidUpdate(prevProps) {
        console.log('hit', this.props.location.pathname)
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const path = this.props.location.pathname;
            const cmsPrefix = '/cms/manage/';


            if (path.startsWith(cmsPrefix)) {
                const subPath = path.slice(cmsPrefix.length);
                const parts = subPath.split('&');

                if (parts.length === 2) {
                    const MenuUrlProps = parts[0];
                    const MenuIDProps = parts[1];
                    if (MenuIDProps === '1') {
                        window.location.reload();
                        return;
                    }
                    this.setState({ MenuUrl: MenuUrlProps, MenuID: MenuIDProps, cmsMenuData: [] }, () => {
                        this.getCmsContent(MenuIDProps, MenuUrlProps);
                    }, () => {
                        this.runDynamicScripts()
                    });
                }
            }

        }
    }
    //dynamic cmsSectionData
    async getCmsContent(MenuID, MenuUrl) {

        const path = this.props.location.pathname;
        const cmsPrefix = '/cms/manage/';
        let MenuUrlProps
        let MenuIDProps
        if (path.startsWith(cmsPrefix)) {
            const subPath = path.slice(cmsPrefix.length);
            console.log(path, subPath, 'cmspath')

            const parts = subPath.split('&');

            if (parts.length === 2) {
                MenuUrlProps = parts[0];
                MenuIDProps = parts[1];
            }
        }
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : MenuIDProps ? MenuIDProps : 1, MenuUrl ? MenuUrl : MenuUrlProps ? MenuUrlProps : 'home');

            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                    cmsUploadData: data?.data[3] !== "" ? data?.data[3] : [],
                    cmsSubheaderData: data?.data[4] !== "" ? data?.data[4] : [],
                    cmsBannerData: data?.data[5][0] !== "" ? data?.data[5][0] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
                if (data.msg == 'Page not found.') {
                    if (this.props.location.pathname.includes('cms/manage')) {
                        window.location.reload()
                        this.props.navigate('/cms/manage')
                    } else {
                        window.location.reload()
                        this.props.navigate('/')
                    }
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    checkDateAndHandleAction = () => {
        const currentDate = new Date();
        const targetDate = new Date('2025-10-30T00:00:00');

        if (currentDate >= targetDate) {
            window.open('https://india-itme.com/#/visitorregistration/ITME2026', '_blank');
        } else {
            const modal = document.getElementById("timer_Modal2");
            if (modal) modal.classList.add("active");
        }
    }

    runDynamicScripts() {
        const slideToggle = (element, duration = 300) => {
            if (window.getComputedStyle(element).display === 'none') {
                element.style.display = 'block';
                const height = element.scrollHeight;
                element.style.overflow = 'hidden';
                element.style.maxHeight = 0;
                element.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => {
                    element.style.maxHeight = height + 'px';
                }, 10);
                setTimeout(() => {
                    element.style.removeProperty('max-height');
                    element.style.removeProperty('overflow');
                    element.style.removeProperty('transition');
                }, duration);
            } else {
                element.style.overflow = 'hidden';
                element.style.maxHeight = element.scrollHeight + 'px';
                element.style.transition = `max-height ${duration}ms ease-in-out`;
                setTimeout(() => {
                    element.style.maxHeight = 0;
                }, 10);
                setTimeout(() => {
                    element.style.display = 'none';
                    element.style.removeProperty('max-height');
                    element.style.removeProperty('overflow');
                    element.style.removeProperty('transition');
                }, duration);
            }
        };

        const preloader = document.getElementById('preloader');
        if (preloader) {
            preloader.style.transition = 'opacity 0.5s ease';
            preloader.style.opacity = '0';
            setTimeout(() => preloader.style.display = 'none', 500);
        }

        if (typeof window.WOW === 'function') {
            new window.WOW().init();
        }
        if (typeof window.AOS === 'object' && window.AOS.init) {
            window.AOS.init({ duration: 1000, mirror: true, once: true, disable: 'mobile' });
        }

        const mobileMenuContainer = document.querySelector('.tgmobile__menu');
        if (mobileMenuContainer) {
            document.querySelectorAll('.tgmenu__wrap .navigation li.menu-item-has-children').forEach(item => {
                if (!item.querySelector('.dropdown-btn')) {
                    item.insertAdjacentHTML('beforeend', '<div class="dropdown-btn"><span class="plus-line"></span></div>');
                }
            });

            const mobileMenuOuter = document.querySelector('.tgmobile__menu-box .tgmobile__menu-outer');
            if (mobileMenuOuter && !mobileMenuOuter.innerHTML) {
                const mainMenuContent = document.querySelector('.tgmenu__wrap .tgmenu__main-menu')?.innerHTML;
                if (mainMenuContent) mobileMenuOuter.innerHTML = mainMenuContent;
            }

            document.querySelectorAll('.tgmobile__menu li.menu-item-has-children .dropdown-btn').forEach(button => {
                button.addEventListener('click', function () {
                    this.classList.toggle('open');
                    const submenu = this.previousElementSibling;
                    if (submenu && submenu.tagName === 'UL') slideToggle(submenu, 300);
                });
            });

            document.querySelector('.mobile-nav-toggler')?.addEventListener('click', () => document.body.classList.add('mobile-menu-visible'));
            document.querySelectorAll('.tgmobile__menu-backdrop, .tgmobile__menu .close-btn').forEach(closer => {
                closer.addEventListener('click', () => document.body.classList.remove('mobile-menu-visible'));
            });
        }

        // --- Sticky Header & Scroll to Top ---
        window.addEventListener('scroll', () => {
            const scroll = window.scrollY;
            const stickyHeader = document.getElementById('sticky-header');
            const scrollToTarget = document.querySelector('.scroll-to-target');
            const headerFixedHeight = document.getElementById('header-fixed-height');

            if (scroll < 245) {
                stickyHeader?.classList.remove("sticky-menu");
                scrollToTarget?.classList.remove('open');
                headerFixedHeight?.classList.remove("active-height");
            } else {
                stickyHeader?.classList.add("sticky-menu");
                scrollToTarget?.classList.add('open');
                headerFixedHeight?.classList.add("active-height");
            }
        });

        const scrollToTargetBtn = document.querySelector('.scroll-to-target');
        if (scrollToTargetBtn) {
            scrollToTargetBtn.addEventListener('click', function () {
                const targetSelector = this.getAttribute('data-target');
                const targetElement = document.querySelector(targetSelector);
                if (targetElement) {
                    window.scrollTo({ top: targetElement.offsetTop, behavior: 'smooth' });
                }
            });
        }


        document.querySelectorAll("[data-background]").forEach(el => {
            el.style.backgroundImage = `url(${el.getAttribute("data-background")})`;
        });
        document.querySelectorAll("[data-bg-color]").forEach(el => {
            el.style.backgroundColor = el.getAttribute("data-bg-color");
        });

        document.querySelector(".search-open-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.add("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.add("search-popup-overlay-open");
        });
        document.querySelector(".search-close-btn")?.addEventListener("click", () => {
            document.querySelector(".search__popup")?.classList.remove("search-opened");
            document.querySelector(".search-popup-overlay")?.classList.remove("search-popup-overlay-open");
        });

        document.querySelector(".menu-tigger")?.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector(".offCanvas__info")?.classList.add("active");
            document.querySelector(".offCanvas__overly")?.classList.add("active");
        });

        document.querySelectorAll(".menu-close, .offCanvas__overly").forEach(el => {
            el.addEventListener("click", () => {
                document.querySelector(".offCanvas__info")?.classList.remove("active");
                document.querySelector(".offCanvas__overly")?.classList.remove("active");
                document.querySelector(".offCanvas__info1")?.classList.remove("active");
            });
        });

        // --- Swiper Sliders ---
        if (window.Swiper) {
            const initSwiper = (selector, options) => {
                const el = document.querySelector(selector);
                if (el && !el.swiper) new window.Swiper(selector, options);
            };

            initSwiper('.slider-active', { spaceBetween: 0, effect: "fade", loop: true, autoplay: { delay: 6000 } });
            initSwiper('.slider-active-two', { spaceBetween: 0, effect: "fade", navigation: { nextEl: ".slider-button-next", prevEl: ".slider-button-prev" } });
            initSwiper('.slider-active-three', { spaceBetween: 0, effect: "fade", loop: true, autoplay: { delay: 6000 } });
            initSwiper('.project_active', { slidesPerView: 3, spaceBetween: 24, loop: true, navigation: { nextEl: ".project-button-next", prevEl: ".project-button-prev" }, breakpoints: { 0: { slidesPerView: 1 }, 576: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 992: { slidesPerView: 3 } } });
            initSwiper('.brand-active', { slidesPerView: 5, spaceBetween: 24, loop: true, breakpoints: { 0: { slidesPerView: 2 }, 576: { slidesPerView: 3 }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 }, 1200: { slidesPerView: 5 } } });
            initSwiper('.testimonial__active', { slidesPerView: 2, spaceBetween: 24, loop: true, autoplay: { delay: 6000 }, navigation: { nextEl: ".testimonial-button-next", prevEl: ".testimonial-button-prev" }, breakpoints: { 0: { slidesPerView: 1 }, 576: { slidesPerView: 1 }, 768: { slidesPerView: 2 } } });
            initSwiper('.AwardSwiper', { slidesPerView: 3, spaceBetween: 24, loop: true, autoplay: { delay: 6000 }, navigation: { nextEl: ".testimonial-button-next", prevEl: ".testimonial-button-prev" }, breakpoints: { 0: { slidesPerView: 1 }, 576: { slidesPerView: 1 }, 768: { slidesPerView: 2 }, 992: { slidesPerView: 3 } } });
        }

        // --- Isotope Filtering ---
        if (typeof window.Isotope === 'function' && typeof window.imagesLoaded === 'function') {
            const grid = document.querySelector('.project-active-two');
            if (grid) {
                window.imagesLoaded(grid, function () {
                    const iso = new window.Isotope(grid, { itemSelector: '.grid-item', percentPosition: true, masonry: { columnWidth: '.grid-item' } });
                    document.querySelectorAll('.project__menu-nav button').forEach(button => {
                        button.addEventListener('click', function (event) {
                            event.preventDefault();
                            const filterValue = this.getAttribute('data-filter');
                            iso.arrange({ filter: filterValue });
                            document.querySelector('.project__menu-nav button.active')?.classList.remove('active');
                            this.classList.add('active');
                        });
                    });
                });
            }
        }

        // --- Countdown Timers ---
        const setupCountdown = (config) => {
            const targetDate = new Date(config.date);
            let interval = null; // Keep a reference to the interval

            const update = () => {
                const now = new Date();
                const remaining = targetDate - now;

                if (remaining <= 0) {
                    if (interval) clearInterval(interval);
                    if (config.days) config.days.textContent = "00";
                    if (config.hours) config.hours.textContent = "00";
                    if (config.minutes) config.minutes.textContent = "00";
                    if (config.seconds) config.seconds.textContent = "00";
                    return;
                }

                const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
                const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

                if (config.days) config.days.textContent = days < 10 ? `0${days}` : days;
                if (config.hours) config.hours.textContent = hours < 10 ? `0${hours}` : hours;
                if (config.minutes) config.minutes.textContent = minutes < 10 ? `0${minutes}` : minutes;
                if (config.seconds) config.seconds.textContent = seconds < 10 ? `0${seconds}` : seconds;
            };

            interval = setInterval(update, 1000);
            update();

            document.querySelectorAll(config.triggerSelector).forEach(trigger => {
                trigger.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (new Date() >= targetDate) {
                        window.open(config.redirectUrl, "_blank");
                    } else {
                        document.getElementById(config.modalId)?.classList.add('active');
                    }
                });
            });

            document.getElementById(config.closeId)?.addEventListener('click', () => {
                document.getElementById(config.modalId)?.classList.remove('active');
            });
        };

        setupCountdown({ date: "2025-02-21T12:00:00", triggerSelector: ".register_click, .booking_click", modalId: "timer_Modal1", closeId: "close_timer_Modal1", redirectUrl: "https://india-itme.com/#/ITME2026", days: document.querySelector(".days1 .number1"), hours: document.querySelector(".hours1 .number1"), minutes: document.querySelector(".minutes1 .number1"), seconds: document.querySelector(".seconds1 .number1") });
        setupCountdown({ date: "2025-12-01T12:00:00", triggerSelector: ".visitor_header_footer_click", modalId: "timer_Modal", closeId: "close_timer_Modal", redirectUrl: "https://india-itme.com/#/visitorregistration/ITME2026", days: document.querySelector(".days .number"), hours: document.querySelector(".hours .number"), minutes: document.querySelector(".minutes .number"), seconds: document.querySelector(".seconds .number") });
        setupCountdown({ date: "2025-02-21T12:00:00", triggerSelector: ".login_btn_click", modalId: "timer_Modal2", closeId: "close_timer_Modal2", redirectUrl: "https://india-itme.com/", days: document.querySelector(".days2 .number2"), hours: document.querySelector(".hours2 .number2"), minutes: document.querySelector(".minutes2 .number2"), seconds: document.querySelector(".seconds2 .number2") });

        // --- jQuery Dependent Plugins ---
        if (typeof window.jQuery !== 'undefined') {
            const $ = window.jQuery;
            if ($.fn.magnificPopup) {
                $('.popup-image').magnificPopup({ type: 'image', gallery: { enabled: true } });
                $('.popup-video').magnificPopup({ type: 'iframe' });
            }
            if ($.fn.marquee) {
                $('.marquee_mode').marquee({ speed: 20, gap: 35, direction: 'left', duplicated: true, pauseOnHover: true });
            }
            if ($.fn.appear && typeof window.Odometer === 'function') {
                $('.odometer').appear(function () {
                    const countNumber = $(this).attr("data-count");
                    $(this).html(countNumber);
                });
            }
        }
    }
    async InsertUpdateCmsContentSection(ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive) {
        try {
            this.setState({ isLoading: true });
            if (SectionContent == '' || SectionContent == '<p><br/></p>') {
                toastError('Kindly Enter Content')
            } else {
                const data = await this.props.insertUpdateCmsContentSection_action(ContentID, MenuID, SeqNo, isFixed, isEdit, SectionContent, isPublish, isactive);
                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Content Added Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async InsertUpdateCmsContent() {
        try {
            const { cmsSectionData } = this.state;
            this.setState({ isLoading: true });
            const hasInvalidContent = cmsSectionData.some(section => {
                const content = section.SectionContent?.trim();
                return !content || content === '<p><br/></p>';
            });

            if (hasInvalidContent) {
                toastError('Kindly Enter Content in all sections');
                this.setState({ isLoading: false });
                return;
            } else {
                const data = await this.props.insertUpdateCmsContent_action(cmsSectionData);

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Contents Added Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async insertUpdateFooter() {
        try {
            const { cmsFooterData } = this.state;
            this.setState({ isLoading: true });
            if (cmsFooterData.FooterContent == '' || cmsFooterData.FooterContent == '<p><br/></p>') {
                toastError('Kindly Enter Footer Section')
            } else {
                const data = await this.props.insertUpdateCmsFooter_action(cmsFooterData);

                if (data.error !== 1) {
                    this.setState({ isLoading: false });
                    if (data.data !== "") {
                        toastSuccess('Footer Saved Successfully')
                        this.getCmsContent()
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async updateCmsContentStatus(ContentID, isactive) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.updateCmsContentStatus_action(MenuID, ContentID, isactive);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Content ${isactive == 1 ? 'Activated' : 'In-Activated'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async deleteCmsStaticFiles(FileID) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.deleteCmsStaticFiles_action(MenuID, FileID);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`File Deleted Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async PublishCmsContent(ContentID, isPublish) {
        try {
            const { MenuID } = this.state;
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsContent_action(MenuID, ContentID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Content ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    async PublishCmsFooter(isPublish) {
        const { cmsFooterData } = this.state
        try {
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsFooter_action(cmsFooterData.FooterID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Footer ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    async PublishCmsBanner(BannerID, isPublish) {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.publishCmsBanner_action(BannerID, isPublish);

            if (data.error !== 1) {
                this.setState({ isLoading: false });
                if (data.data !== "") {
                    toastSuccess(`Banner ${isPublish == 1 ? 'Published' : 'Unpublished'} Successfully`)
                    this.getCmsContent();
                }
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    UploadBannerFile = async () => {
        const { cmsBannerData } = this.state
        console.log(cmsBannerData, 'cmsBannerData')
        if (cmsBannerData.length == 0 || cmsBannerData == []) {
            toastError('Kindly Upload File')
            return
        }
        try {
            this.setState({ isLoading: true });
            if (cmsBannerData.length == 0) {
                toastError('Kindly Upload File')
                this.setState({ bannerFileErr: 'Kindly Upload File' })
            } else {
                const data = await this.props.insertUpdateCmsBanner_action(cmsBannerData);
                if (data.error !== 1) {
                    this.setState({ isLoading: false, isStaticUploadOpenBanner: false, bannerFileErr: '' });
                    if (data.data !== "") {
                        toastSuccess('Banner Uploaded Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    UploadStaticFiles = async () => {
        const { cmsUploadData } = this.state
        if (cmsUploadData.length == 0 || cmsUploadData == []) {
            toastError('Kindly Upload Files')
            return
        }
        try {
            this.setState({ isLoading: true });
            if (cmsUploadData.length == 0) {
                toastError('Kindly Upload Files')
            } else {
                const data = await this.props.insertUpdateCMSStaticUploads_action(cmsUploadData);
                if (data.error !== 1) {
                    this.setState({ isLoading: false, isStaticUploadOpen: false });
                    if (data.data !== "") {
                        toastSuccess('Files Uploaded Successfully')
                        this.getCmsContent();
                    }
                } else {
                    this.setState({ isLoading: false });
                    toastError(data.msg);
                }
            }

        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }
    toggleUploadFileOpen = () => {
        this.setState({ isStaticUploadOpen: true })
    }
    toggleUploadFileOpenBanner = () => {
        this.setState({ isStaticUploadOpenBanner: true })
    }
    handleAddSection = () => {
        const { ContentID, MenuID } = this.state;
        const sectionName = `section-${sectionCounter++}`;

        const newSection = {
            SectionName: sectionName,
            ContentID: ContentID ? ContentID : 0,
            MenuID: MenuID ? MenuID : 1,
            SeqNo: this.state.cmsSectionData.length + 1,
            isFixed: false,
            isEdit: true,
            SectionContent: '',
            isactive: 1,
            isPublish: 0
        };

        this.setState(
            prevState => ({
                cmsSectionData: [...prevState.cmsSectionData, newSection]
            }),
            () => {
                // Scroll to the new section after it's rendered
                setTimeout(() => {
                    const el = document.getElementById(sectionName);
                    if (el) {
                        el?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                }, 100);
            }
        );
    };

    handleEditorChange = (content, index) => {
        const cmsSectionData = [...this.state.cmsSectionData];
        cmsSectionData[index].SectionContent = content;
        this.setState({ cmsSectionData });
    };
    handleEditorChangeFooter = (content) => {
        const cmsFooterData = { ...this.state.cmsFooterData }; // shallow copy of the object
        cmsFooterData.FooterContent = content;
        this.setState({ cmsFooterData });
    };

    onDragEnd = (result) => {
        const { destination, source } = result;
        if (!destination) return;

        const sourceSection = this.state.cmsSectionData[source.index];
        const destSection = this.state.cmsSectionData[destination.index];

        // Don't allow drag if either isFixed
        if (sourceSection.isFixed || destSection.isFixed) return;

        const items = Array.from(this.state.cmsSectionData);
        const [reorderedItem] = items.splice(source.index, 1);
        items.splice(destination.index, 0, reorderedItem);

        // Update sequence numbers
        items.forEach((item, index) => {
            item.SeqNo = index + 1;
        });

        this.setState({ cmsSectionData: items });
    };
    handleRemoveSection = (indexToRemove, ContentID) => {
        let updatedcmsSectionData;

        if (ContentID !== 0) {
            updatedcmsSectionData = this.state.cmsSectionData.map((section, index) => {
                if (index === indexToRemove) {
                    return {
                        ...section,
                        isactive: 0
                    };
                }
                return section;
            });
        } else {
            updatedcmsSectionData = this.state.cmsSectionData.filter((_, index) => index !== indexToRemove);
        }

        const reSequenced = updatedcmsSectionData.map((section, idx) => ({
            ...section,
            SeqNo: idx + 1
        }));

        this.setState({ cmsSectionData: reSequenced });
    };
    toggleSectionStatus = (index, ContentID, isactive) => {
        const updatedcmsSectionData = this.state.cmsSectionData.map((section, idx) => {
            if (idx === index) {
                return {
                    ...section,
                    isactive: section.isactive ? 0 : 1,
                };
            }
            return section;
        });

        this.setState({ cmsSectionData: updatedcmsSectionData }, () => {
            this.updateCmsContentStatus(ContentID, !isactive)
        });
    };
    handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        if (files.length > 10) {
            alert("You can upload a maximum of 10 files.");
            return;
        }

        const oversized = files.find(file => file.size > 20 * 1024 * 1024); // 20MB
        if (oversized) {
            alert(`File "${oversized.name}" exceeds the 20MB limit.`);
            return;
        }

        const newUploadData = files.map(file => {
            const reader = new FileReader();
            const fileExt = file.name.split('.').pop();

            return new Promise((resolve) => {
                reader.onload = (e) => {
                    resolve({
                        FileID: 0,
                        MenuID: this.state.MenuID, // adjust as per your logic
                        FilePath: "",
                        FileName: file.name,
                        formFile: e.target.result.split(',')[1], // base64 part only
                        formFileType: fileExt,
                        FilePath: '',
                        isPublish: 1,
                        isActive: 1
                    });
                };
                reader.readAsDataURL(file);
            });
        });

        Promise.all(newUploadData).then(uploadData => {
            this.setState(prevState => ({
                cmsUploadData: [...(prevState.cmsUploadData || []), ...uploadData]
            }));
        });
    };

    removeFile = (index, FileID) => {
        this.setState(prevState => {
            const updatedFiles = [...prevState.cmsUploadData];
            const file = updatedFiles[index];
            if (file.FileID && file.FileID !== 0) {
                updatedFiles[index].isActive = 0;
                this.deleteCmsStaticFiles(FileID);
            } else {
                updatedFiles.splice(index, 1); // Remove completely
            }
            return { cmsUploadData: updatedFiles };
        });
    };
    clearFileInput() {
        this.setState({ cmsBannerData: [] })
    }
    handleBannerChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.size > 10 * 1024 * 1024) { // 10 MB limit
            alert(`File "${file.name}" exceeds the 10MB limit.`);
            return;
        }
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed.");
            event.target.value = null;
            this.clearFileInput();
            return;
        }
        const fileExt = file.name.split('.').pop();

        const reader = new FileReader();
        reader.onload = (e) => {
            const base64 = e.target.result;
            const uploadData = {
                BannerID: null,
                BannerFilepath: "",
                FilePreview: base64,
                FileName: file.name,
                formfile: base64.split(",")[1],
                formFileType: fileExt,
                isPublish: 1,
                isActive: 1
            };
            this.setState((prevState) => ({
                cmsBannerData: Array.isArray(prevState.cmsBannerData) ? [...prevState.cmsBannerData, uploadData] : [uploadData]
            }))
        };
        reader.readAsDataURL(file);
    };


    render() {
        const { isLoading, cmsSectionData, cmsMenuData, cmsFooterData, MenuID, bannerFileErr, isStaticUploadOpen, MenuUrl, isStaticUploadOpenBanner, downloadUrl, cmsBannerData } = this.state

        return (
            <>
                {isLoading ? (<Loader></Loader>) : (null)}
                <Header headerNavs={cmsMenuData} />

                <main className="main-area fix ">
                    <section className="slider__area-two">
                        <div className="swiper slider-active-two">
                            <div className="swiper-wrapper">
                                <div className="swiper-slide slider__bg-two">
                                    <div className="container custom_container_data">
                                        <div className="row justify-content-center">
                                            <div className="col-xl-12 col-lg-12">
                                                <div className="slider__content-two header_text">
                                                    {/* cms */}
                                                    <div className=" mx-2" style={{ margin: 'auto' }}>
                                                        <div className='d-flex justify-content-center '>
                                                            <h4 className="title cms-section-tit mb-3">CMS Section Editors {" "}
                                                            </h4>
                                                        </div>
                                                        <button className="registerNow_btn register_click mb-4" onClick={this.handleAddSection}>Add Section</button>
                                                        <button className="registerNow_btn register_click mx-2 mb-4" onClick={this.toggleUploadFileOpen}>Upload Files</button>
                                                        <button className="registerNow_btn register_click mx-2 mb-4" onClick={this.toggleUploadFileOpenBanner}>Upload Banner</button>
                                                        <DragDropContext onDragEnd={this.onDragEnd}>
                                                            <Droppable droppableId="cmsSectionData-droppable">
                                                                {(provided) => (
                                                                    <div {...provided.droppableProps} ref={provided.innerRef}>
                                                                        {cmsSectionData?.length > 0 ? cmsSectionData?.map((section, index) => (
                                                                            <Draggable
                                                                                key={section.ContentID + '-' + index}
                                                                                draggableId={(section.ContentID ? section.ContentID.toString() : `new-${index}`)}
                                                                                index={index}
                                                                                isDragDisabled={section.isFixed}>
                                                                                {(provided) => (
                                                                                    <div
                                                                                        id={section.SectionName} // <- ADD THIS
                                                                                        className="focus-sec first-sec"
                                                                                        ref={provided.innerRef}
                                                                                        {...provided.draggableProps}
                                                                                        style={{
                                                                                            border: '1px solid #ccc',
                                                                                            padding: '10px',
                                                                                            borderRadius: '10px',
                                                                                            marginBottom: '15px',
                                                                                            backgroundColor: '#f9f9f9',
                                                                                            ...provided.draggableProps.style
                                                                                        }}>
                                                                                        {/* DRAG HANDLE ONLY APPLIED HERE */}
                                                                                        <div
                                                                                            {...provided.dragHandleProps}
                                                                                            style={{
                                                                                                marginBottom: '5px',
                                                                                                display: 'flex',
                                                                                                justifyContent: 'space-between',
                                                                                                alignItems: 'center',
                                                                                                cursor: 'grab',
                                                                                            }}
                                                                                        >
                                                                                            <strong style={{ color: '#007bff' }}>Section #{section.SeqNo}</strong>
                                                                                            <div>
                                                                                                {section.isFixed && (
                                                                                                    <span style={{ color: 'red', marginRight: '10px' }}>
                                                                                                        (Fixed)
                                                                                                    </span>
                                                                                                )}
                                                                                                <button
                                                                                                    className="btn btn-sm px-3 p-1 rounded-1 edit-submit-btn mb-1 mt-1"
                                                                                                    onClick={() =>
                                                                                                        this.InsertUpdateCmsContentSection(
                                                                                                            section.ContentID,
                                                                                                            section.MenuID,
                                                                                                            section.SeqNo,
                                                                                                            section.isFixed,
                                                                                                            section.isEdit,
                                                                                                            section.SectionContent,
                                                                                                            section.isPublish,
                                                                                                            section.isactive
                                                                                                        )
                                                                                                    }
                                                                                                >
                                                                                                    Submit
                                                                                                </button>
                                                                                                <button
                                                                                                    className="btn btn-sm px-3 p-1 rounded-1 ml-1 add-sec-btn mx-2 mb-1 mt-1"
                                                                                                    onClick={this.handleAddSection}
                                                                                                >
                                                                                                    Add Section
                                                                                                </button>
                                                                                                {section.isactive ? (
                                                                                                    <>
                                                                                                        {section.isPublish ? (
                                                                                                            <button
                                                                                                                className="btn btn-sm p-1 px-3  rounded-1 add-unp-btn mb-1 mt-1"
                                                                                                                onClick={() =>
                                                                                                                    this.PublishCmsContent(section.ContentID, 0)
                                                                                                                }
                                                                                                            >
                                                                                                                Unpublish
                                                                                                            </button>

                                                                                                        ) : (
                                                                                                            <button
                                                                                                                className="btn btn-sm p-1 px-3 mx-1 rounded-1 btn-pub-btn mx-2 mb-1 mt-1"
                                                                                                                onClick={() =>
                                                                                                                    this.PublishCmsContent(section.ContentID, 1)
                                                                                                                }
                                                                                                            >
                                                                                                                Publish
                                                                                                            </button>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : <></>}
                                                                                                {!section.isFixed && (
                                                                                                    <>
                                                                                                        {section.ContentID === 0 ? (
                                                                                                            <button
                                                                                                                className="btn btn-sm px-3 p-1 rounded-1"
                                                                                                                onClick={() =>
                                                                                                                    this.handleRemoveSection(index, section.ContentID)
                                                                                                                }
                                                                                                            >
                                                                                                                Remove
                                                                                                            </button>
                                                                                                        ) : (
                                                                                                            <button
                                                                                                                className={`btn btn-sm px-3 p-1 mx-2 rounded-1 btn-pub-btn-1 ml-1 ${section.isactive && 'btn-in-act-btn ml-1'
                                                                                                                    }`}
                                                                                                                onClick={() =>
                                                                                                                    this.toggleSectionStatus(
                                                                                                                        index,
                                                                                                                        section.ContentID,
                                                                                                                        section.isactive
                                                                                                                    )
                                                                                                                }
                                                                                                            >
                                                                                                                {section.isactive ? 'In-Activate' : 'Activate'}
                                                                                                            </button>
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Editable Content */}
                                                                                        {section.isEdit ? (
                                                                                            <JoditEditor
                                                                                                key={section.ContentID || 0}
                                                                                                value={section.SectionContent}
                                                                                                config={joditConfig}
                                                                                                onChange={(content) =>
                                                                                                    this.handleEditorChange(content, index)
                                                                                                }
                                                                                            />
                                                                                        ) : (
                                                                                            <div
                                                                                                dangerouslySetInnerHTML={{ __html: section.SectionContent }}
                                                                                            />
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </Draggable>
                                                                        )) : null}
                                                                        {provided.placeholder}
                                                                    </div>
                                                                )}
                                                            </Droppable>
                                                        </DragDropContext>

                                                        {cmsSectionData.length > 0 && (
                                                            <div style={{ textAlign: 'center' }}>
                                                                <a className="registerNow_btn register_click" onClick={() => this.InsertUpdateCmsContent()}>
                                                                    Submit Contents
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <hr />
                                                    <div className="p-0 mb-2 d-flex justify-content-center">
                                                        <p className="title cms-section-tit mb-2">Edit Footer {" "}</p>
                                                    </div>

                                                    <a className="registerNow_btn register_click" onClick={() => this.insertUpdateFooter()}>Submit Footer</a>
                                                    {cmsFooterData?.isPublish ? <>
                                                        <a className="registerNow_btn register_click mx-2" onClick={() => this.PublishCmsFooter(0)}>Unpublish Footer</a>
                                                    </> : <>
                                                        <a className="registerNow_btn register_click " onClick={() => this.PublishCmsFooter(1)}>Publish Footer</a>
                                                    </>}
                                                    <div className='mb-5'></div>
                                                    <JoditEditor value={cmsFooterData?.FooterContent} config={joditConfig}
                                                        onChange={(content) => this.handleEditorChangeFooter(content)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </section>

                    <Modal show={isStaticUploadOpenBanner} size="xl" style={{ left: '2%', top: "10%" }}>
                        <Modal.Header>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>

                                {/* Left Side: Title */}
                                <Modal.Title>
                                    <h6 style={{ color: 'black', margin: 0 }}>Upload Banner</h6>
                                </Modal.Title>

                                {/* Right Side: Buttons */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    {(cmsBannerData?.BannerFilepath ? cmsBannerData?.BannerFilepath : cmsBannerData?.FilePreview) ? (
                                        <button
                                            className="btn btn-sm p-1 px-3 btn-outline-moddanger rounded-1 mb-1 mt-1"
                                            onClick={this.clearFileInput}
                                        >
                                            Remove
                                        </button>
                                    ) : (
                                        <>
                                            <label className="btn btn-sm p-1 px-3 btn-outline-modsuccess rounded-1 mb-1 mt-1">
                                                Upload
                                                <input
                                                    type="file"
                                                    accept=".jpg,.jpeg,.png"
                                                    onChange={this.handleBannerChange}
                                                    ref={(ref) => (this.fileInputRef = ref)}
                                                    style={{ display: 'none' }}
                                                />
                                            </label>
                                        </>
                                    )}


                                    {cmsBannerData?.isActive && (
                                        cmsBannerData?.isPublish == true ? (
                                            <button
                                                className="btn btn-sm p-1 px-2 rounded-1 btn-outline-modsec mb-1 mt-1"
                                                onClick={() => this.PublishCmsBanner(cmsBannerData?.BannerID, 0)}
                                            >
                                                Unpublish
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-sm p-1 px-3 rounded-1 btn-pub-btn mb-1 mt-1"
                                                onClick={() => this.PublishCmsBanner(cmsBannerData?.BannerID, 1)}
                                            >
                                                Publish
                                            </button>
                                        )
                                    )}

                                    <span
                                        onClick={() => this.setState({ isStaticUploadOpenBanner: false })}
                                        style={{ cursor: "pointer", fontWeight: "800", marginLeft: '10px' }}
                                    >
                                        X
                                    </span>
                                </div>
                            </div>
                        </Modal.Header>

                        <Modal.Body style={{ height: 'calc(100vh - 375px)' }}>
                            {((cmsBannerData?.BannerFilepath != "" ? cmsBannerData?.BannerFilepath : cmsBannerData?.FilePreview) || (cmsBannerData?.[0]?.BannerFilepath != "" ? cmsBannerData?.[0]?.BannerFilepath : cmsBannerData?.[0]?.FilePreview)) ? (
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <img
                                        src={cmsBannerData?.BannerFilepath ? cmsBannerData?.BannerFilepath : cmsBannerData?.FilePreview}
                                        alt="Preview"
                                        style={{ width: "250px", height: "250px", objectFit: "contain", border: "1px solid #ccc" }}
                                    />
                                </div>
                            ) : (<>
                                {/* <label htmlFor="upload-files" className="btn btn-primary mb-3">
                                    Upload Banner
                                </label> */}
                                {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{bannerFileErr}</span>}
                            </>
                            )}

                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-sm px-3 mb-1 mx-2 p-2 up-btn" onClick={() => this.setState({ isStaticUploadOpenBanner: false })}>Close</button>
                            <button className="btn btn-sm px-3 mb-1 mx-2  p-2 up-btn" onClick={this.UploadBannerFile}>Submit</button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={isStaticUploadOpen} size="xl" style={{ left: '2%', top: "10%" }}>
                        <Modal.Header>
                            <Modal.Title style={{ width: '100%', textAlign: 'center' }}>
                                {/* <div > */}
                                <h6 style={{ color: 'black' }}> Upload Files - {MenuUrl ? MenuUrl : (MenuID == 1 && 'Home')}</h6>
                                {/* </div> */}
                            </Modal.Title>
                            <span
                                onClick={() => this.setState({ isStaticUploadOpen: false })}
                                style={{ cursor: "pointer", fontWeight: "800", marginRight: '15px' }}
                            >
                                X
                            </span>
                        </Modal.Header>
                        <Modal.Body className='modal-scroll'>
                            <label htmlFor="upload-files" className="btn btn-primary mb-3 px-2 py-2 rounded-3 up-btn border">
                                Upload Files
                            </label>
                            <input
                                id="upload-files"
                                type="file"
                                multiple
                                accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.xls,.xlsx,.csv,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                style={{ display: 'none' }}
                                onChange={this.handleFileChange}
                            />

                            {this.state.cmsUploadData?.length > 0 && (
                                <div style={{ maxHeight: "20rem", overflowY: "auto" }} className="table-responsive">
                                    <table className="table table-bordered upload-table mb-0">
                                        <thead className="table-light sticky-top">
                                            <tr>
                                                <th>File Name</th>
                                                <th>File URL</th>
                                                <th className='text-center'>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.cmsUploadData.map((file, index) => (
                                                file.isActive === 1 && (
                                                    <tr key={index}>
                                                        <td>
                                                            <a
                                                                title='View'
                                                                href={file.FileID && `${downloadUrl + file.FilePath}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                {file.FileName}
                                                            </a>
                                                        </td>
                                                        <td
                                                            style={{
                                                                cursor: file.FileID ? "pointer" : "default",
                                                                color: file.FileID ? "#007bff" : "#444"
                                                            }}
                                                            title={file.FileID ? "Click to copy URL" : ""}
                                                            onClick={() => {
                                                                if (file.FileID) {
                                                                    const fullUrl = `${downloadUrl + file.FilePath}`;
                                                                    navigator.clipboard.writeText(fullUrl)
                                                                        .then(() => toastSuccess("URL copied to clipboard!"))
                                                                        .catch(err => toastError("Failed to copy URL: ", err));
                                                                }
                                                            }}
                                                        >
                                                            {file.FileID ? `${downloadUrl + file.FilePath}` : file.FileName}
                                                        </td>
                                                        <td className='text-center'>
                                                            <i
                                                                onClick={() => this.removeFile(index, file.FileID)}
                                                                className="fas fa-trash text-danger"
                                                                style={{ cursor: "pointer" }}
                                                            ></i>
                                                        </td>
                                                    </tr>
                                                )
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-sm px-3 btn-outline-secndary mb-1 mx-2 px-2 py-2 rounded-3 up-btn border" onClick={() => this.setState({ isStaticUploadOpen: false })}>Close</button>
                            <button className="btn btn-sm px-3 mb-1 btn-outline-success mx-2 px-2 py-2 rounded-3 up-btn border" onClick={this.UploadStaticFiles}>Submit</button>
                        </Modal.Footer>
                    </Modal>
                </main>
                {/* <Footer  /> */}
                <ToastContainer />

            </>
        )

    }
}

export default withRouter(connect(null, {
    getCmsContent_action, insertUpdateCmsContent_action,
    insertUpdateCmsFooter_action, publishCmsContent_action,
    publishCmsFooter_action, insertUpdateCmsContentSection_action,
    updateCmsContentStatus_action, insertUpdateCMSStaticUploads_action,
    deleteCmsStaticFiles_action, publishCmsBanner_action,
    insertUpdateCmsBanner_action
})(cmsHome));